import { navigatorLanguage } from '@geovelo-frontends/commons';
import { navigate } from 'gatsby';
import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { AppContext } from '../context';
import useSiteMetadata from '../hooks/site-metadata';
import { TPageProps } from '../page-props';

function GeoaggloPage({
  pageContext: { bounds },
  location: { pathname, search },
}: TPageProps): JSX.Element {
  const {
    actions: { setMapInitialBounds },
  } = useContext(AppContext);
  const metadata = useSiteMetadata();

  useEffect(() => {
    if (bounds) {
      const [east, south, west, north] = bounds;
      setMapInitialBounds([east, south, west, north]);
      navigate(`/${navigatorLanguage}/route${search || ''}`, { replace: true });
    }
  }, []);

  const title = metadata?.title || 'Geovelo';
  const siteUrl = metadata?.siteUrl || process.env.GATSBY_GEOVELO_SITE_URL || '';
  const url = `${siteUrl}${pathname}`;

  return (
    <Helmet>
      <html lang="fr" />
      <link href={metadata?.icon || '/favicon.svg'} id="icon" rel="icon" />

      <title>{title}</title>

      <meta content={title} property="og:title" />
      <meta content={url} property="og:url" />
      <meta content={`${siteUrl}/'baseline-fr.png'`} property="og:image" />

      <meta content={title} property="twitter:title" />
      <meta content={url} property="twitter:url" />
      <meta content={`${siteUrl}/'baseline-fr.png'`} property="twitter:image" />

      <meta content="kchrau2r7qiz13zlgnhoq91gd1advn" name="facebook-domain-verification" />

      <link href={`${siteUrl}/route`} rel="canonical" />
    </Helmet>
  );
}

export default GeoaggloPage;
